import { Sparkles, Wand2, ShieldCheck, MapPin } from "lucide-react";
import { SESSIONS } from "../data/conferenceData";

const ICON_MAP = {
  sparkles: Sparkles,
  wand: Wand2,
  shield: ShieldCheck,
};

// Accent rotation matches Pre K (primary, gold, maroon, primaryDark) - cycle through
const ACCENTS = [
  { bg: "var(--primary)", text: "white" },
  { bg: "var(--gold)", text: "var(--primary-dark)" },
  { bg: "var(--maroon)", text: "white" },
];

export default function Sessions() {
  return (
    <div style={{ padding: "16px", paddingBottom: "40px" }} data-testid="sessions-page">
      <h2
        style={{
          fontSize: "22px",
          fontWeight: 800,
          color: "var(--primary-dark)",
          marginBottom: "4px",
        }}
      >
        Today's Sessions
      </h2>
      <p
        style={{
          color: "var(--text-muted)",
          fontSize: "14px",
          marginBottom: "20px",
        }}
      >
        Three powerful breakouts.
      </p>

      {SESSIONS.map((s, idx) => {
        const accent = ACCENTS[idx % ACCENTS.length];
        const Icon = ICON_MAP[s.icon] || Sparkles;
        return (
          <div
            key={s.id}
            data-testid={`session-card-${s.id}`}
            className="shadow-card"
            style={{
              backgroundColor: "var(--surface)",
              borderRadius: "16px",
              padding: "16px",
              borderLeftWidth: "5px",
              borderLeftStyle: "solid",
              borderLeftColor: accent.bg,
              marginBottom: "14px",
            }}
          >
            <div
              className="flex items-center"
              style={{ marginBottom: "10px", gap: "12px" }}
            >
              <div
                className="flex items-center justify-center flex-shrink-0"
                style={{
                  width: "46px",
                  height: "46px",
                  borderRadius: "12px",
                  backgroundColor: accent.bg,
                }}
              >
                <Icon size={22} color={accent.text} strokeWidth={2} />
              </div>
              <div className="flex-1 min-w-0">
                <p
                  style={{
                    fontSize: "17px",
                    fontWeight: 800,
                    color: "var(--primary-dark)",
                    lineHeight: "22px",
                  }}
                >
                  {s.title}
                </p>
                <div
                  className="flex items-center"
                  style={{ gap: "4px", marginTop: "2px" }}
                >
                  <MapPin size={14} color={accent.bg} />
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: 700,
                      color: accent.bg,
                    }}
                  >
                    {s.location}
                  </span>
                </div>
              </div>
            </div>
            <p
              style={{
                color: "var(--text-muted)",
                fontSize: "14px",
                lineHeight: "21px",
                whiteSpace: "pre-line",
              }}
              data-testid={`session-desc-${s.id}`}
            >
              {s.description}
            </p>
          </div>
        );
      })}
    </div>
  );
}
